import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Person } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntityMeta, EntityMetaProps, useAuth } from '@shapeable/ui';
const cls = classNames('feed-entry-meta');

// -------- Types -------->

// -------- Props -------->

export type PersonCardMetaProps = Classable & HasChildren & Omit<EntityMetaProps, 'fields'> & { 
  entity?: Person;
};

export const PersonCardMetaDefaultProps: Omit<PersonCardMetaProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`

  `,
});

const OrganisationStyles = breakpoints({
  base: css`
    color: ${theme.COLOR('text')};
  `,
});

const MetaStyles = breakpoints({
  base: css`
    padding-top: ${theme.UNIT(2)};
  `,
});

// -------- Components -------->

const My = {
    Container: styled.div<ContainerProps>`${ContainerStyles}`,
      TypeLabel: styled.span`${OrganisationStyles}`,
      Meta: styled(EntityMeta)<ContainerProps>`${MetaStyles}`,
};

export const PersonCardMeta: Shapeable.FC<PersonCardMetaProps> = (props) => {
  const { className, children, entity } = props;

  const auth = useAuth();

  const { isAuthenticated } = auth || {};

  const { organisation, hideEmail, email } = entity || {};

  const hasOrganisation = !!organisation;
  const hasEmail = !hideEmail && !!email && isAuthenticated;
  
  return (
    <My.Container className={cls.name(className)}>
      {
        hasOrganisation && <My.TypeLabel>{organisation?.name}</My.TypeLabel>
      }
      {
        hasEmail && <My.Meta 
        entity={entity} 
        fields={[ 'email' ]} 
        className={cls.name(className)} 
      />
      }
    </My.Container>
  )
};

PersonCardMeta.defaultProps = PersonCardMetaDefaultProps;
PersonCardMeta.cls = cls;